import Title from './Title'
import Subtitle from './Subtitle'
import Offer from './Offer'
import Link from './Link'
import Body from './Body'

export default Object.assign(Offer, {
  Subtitle,
  Title,
  Link,
  Body,
})
